export default "__VITE_ASSET__C5E9EKeq__"